import { TICKETING_FORM_KEY } from './ticketingFormKeys';
import {
  HrEmployeeItRequestForm,
  HrEmployeeEditItRequestForm,
  HrEmployeeDeleteItRequestForm,
} from './forms/HrEmployeeItRequestForm';
import { WarehouseTicketRequestForm } from './forms/WarehouseTicketRequestForm';
import { GeneralTicketRequestForm } from './forms/GeneralTicketRequestForm';
import { GeneralItTicketRequestForm } from './forms/GeneralItTicketRequestForm';

export {
  TICKETING_FORM_KEY,
  TICKETING_FORM_OPTIONS,
  TICKETING_FORM_META,
  resolveCategoryFormKey,
  getTicketingFormMeta,
} from './ticketingFormKeys';

const FORM_COMPONENTS = {
  [TICKETING_FORM_KEY.HR_EMPLOYEE_IT]: HrEmployeeItRequestForm,
  [TICKETING_FORM_KEY.HR_EMPLOYEE_EDIT_IT]: HrEmployeeEditItRequestForm,
  [TICKETING_FORM_KEY.HR_EMPLOYEE_DELETE_IT]: HrEmployeeDeleteItRequestForm,
  [TICKETING_FORM_KEY.WAREHOUSE_ACCESS]: WarehouseTicketRequestForm,
  [TICKETING_FORM_KEY.GENERAL]: GeneralTicketRequestForm,
  [TICKETING_FORM_KEY.GENERAL_IT]: GeneralItTicketRequestForm,
};

export function getTicketingFormComponent(formKey) {
  return FORM_COMPONENTS[formKey] || HrEmployeeItRequestForm;
}
